import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { MillAdjustment } from "../models/MillAdjustment";

const moment = getMomentTz();

export const getMillAdjustments = async (
	params: {
		startDate: Date;
		endDate: Date;
		standId?: number | null;
		operatorId?: number | null;
		adjustmentTypeId?: number | null;
		adjustmentReasonId?: number | null;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "StartDate", value: params.startDate.toISOString() },
		{ name: "EndDate", value: params.endDate.toISOString() },
		{ name: "StandId", value: params.standId || null },
		{ name: "OperatorId", value: params.operatorId || null },
		{ name: "AdjustmentTypeId", value: params.adjustmentTypeId || null },
		{ name: "AdjustmentReasonId", value: params.adjustmentReasonId || null },
	];

	const resp = await apiService.callV2(
		"[M2].[GetMillAdjustmentsReport]",
		parameters,
		signal,
	);

	if (resp.ok) {
		let adjustmentsData = get(resp, "data.tables[0].rows", []) as any[];

		adjustmentsData = adjustmentsData.map((row) => ({
			...row,
			timestamp: row.timestamp ? moment.utc(row.timestamp).toDate() : null,
			start: row.start ? moment.utc(row.start).toDate() : null,
			end: row.end ? moment.utc(row.end).toDate() : null,
		}));

		return adjustmentsData as MillAdjustment[];
	} else {
		throw new Error(resp.message || "Error fetching mill adjustments");
	}
};
